import * as React from 'react';

const AiBrainHandoff = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={25} height={24} fill="none">
    <mask
      id="aiBrainHandoffColor1"
      width={25}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}>
      <path fill="#D9D9D9" d="M.25 0h24v24h-24z" />
    </mask>
    <g mask="url(#aiBrainHandoffColor1)">
      <path
        fill="#1C1B1F"
        d="m8.115 14.173 2.177-3.038h4.568L8.115 5.83v8.342Zm6.9 6.385c-.319.15-.638.167-.957.048a1.238 1.238 0 0 1-.706-.658l-2.962-6.364-2.132 2.972c-.258.361-.596.475-1.015.341-.418-.134-.628-.42-.628-.858V4.607c0-.378.17-.65.51-.814.34-.164.66-.128.961.106l9.053 7.123c.344.264.444.599.299 1.004-.146.405-.435.607-.867.607h-3.873l2.927 6.26c.151.32.167.639.048.958-.12.32-.338.554-.658.706Z"
      />
    </g>
  </svg>
);

export default AiBrainHandoff;
